import { useCallback, useMemo, useRef, useState } from 'react';

export const useAudioInputVolumeMeter = () => {
  const [isFirtsClick, setIsFirtsClick] = useState(true);
  const [listening, setListening] = useState(false);
  const [volume, setVolume] = useState<number>(0);

  const audioContext = useRef<AudioContext>();
  const mediaStream = useRef<MediaStream>();

  const listenMusic = useCallback(async () => {
    try {
      mediaStream.current = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });

      if (!mediaStream.current) {
        setListening(false);
        return;
      }

      const stream = mediaStream.current;

      if (isFirtsClick) {
        audioContext.current = new AudioContext();
        await audioContext.current.audioWorklet.addModule(
          '/assets/js/volumeMeter.js',
        );
        const microphone = audioContext.current.createMediaStreamSource(stream);

        const node = new AudioWorkletNode(audioContext.current, 'vumeter');
        node.port.onmessage = (event) => {
          let _volume = 0;
          const _sensibility = 5;
          if (event.data.volume) {
            _volume = event.data.volume;
          }
          setVolume((_volume * 100) / _sensibility);
        };
        microphone.connect(node).connect(audioContext.current.destination);
        setIsFirtsClick(false);
      }
      if (!audioContext.current) return;
      audioContext.current.resume();
      setListening(true);
    } catch (e) {
      alert(e);
    }
  }, [isFirtsClick]);

  const stopListenMusic = () => {
    audioContext.current?.suspend();
    mediaStream.current?.getTracks().forEach((track) => track.stop());
    setListening(false);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  return useMemo(
    () => ({
      volume,
      listening,
      listenMusic,
      stopListenMusic,
    }),
    [volume, listening, listenMusic],
  );
};
